<div class="month-calendar">
    <div class="header">
        <div class="title">{{ 'CALENDAR.MONTH.' + (monthDate.getMonth() + 1) | translate }}</div>
        <div class="nav-buttons">
            <button class="nav small"
                    (click)="previousMonth()"
            >
                <i class="ri-arrow-left-line"></i>
            </button>
            <button class="nav small"
                    [disabled]="disabledNextButton"
                    (click)="nextMonth()"
            >
                <i class="ri-arrow-right-line"></i>
            </button>
        </div>
    </div>

    <div class="weekdays"
         role="row">
        @for (label of ['1', '2', '3', '4', '5', '6', '7']; track label) {
            <div class="weekday">
                {{ 'CALENDAR.DAYS.' + label | translate }}
            </div>
        }
    </div>

    <div class="calendar-grid"
         role="grid"
         aria-label="Month calendar"
         [class.weeks-6]="weeks.length / 7 === 6"
         [class.weeks-4]="weeks.length / 7 === 4"
    >
        <ng-container>
            @for (day of weeks; track day.date; let index = $index; let count = $count) {
                <div
                        class="cell"
                        [class.outside]="!day.inMonth"
                        [class.first-column]="index % 7 === 0"
                        [class.last-row]="count - 7 < index + 1"
                        (click)="onDayClick(day)"
                        role="gridcell"
                        aria-selected="false"
                >
                    <div class="cell-head">
                        <span class="date">{{ day.date.getDate() }}</span>
                    </div>

                    <div class="cell-body">
                        <div class="items">
                            @for (it of day.visibleItems; track it.id) {
                                <div class="item"
                                     [attr.data-type]="it.type"
                                     (click)="onItemClick(day.date, it, $event)"
                                     title="{{ it.title }}"
                                >
                                        <span class="item-dot"
                                              aria-hidden="true"
                                        ></span>
                                    <span class="item-text">{{ it.value || it.title }}</span>
                                </div>
                            }

                            <button *ngIf="day.extra > 0"
                                    class="more"
                                    (click)="$event.stopPropagation(); onDayClick(day)"
                            >
                                Еще {{ day.extra }}<i class="ri-arrow-right-up-line"></i>
                            </button>
                        </div>
                    </div>
                </div>
            }
        </ng-container>
    </div>

    <div class="legend">
        @for (legend of calendarLegend; track legend.type) {
            <div class="legend-item"><span class="dot {{legend.type}}"></span> {{ legend.title }}</div>
        }
    </div>
</div>
